import { IDisplayColumn } from "../../interfaces/ManageView";
import { DisplayColumn } from "../../interfaces/ViewFolderResponse";

export const MapDisplayColumnToArtemisDisplayColumn = (displayColumns: IDisplayColumn[]): DisplayColumn[] => {
    if (!displayColumns) {
        return [];
    }
    return displayColumns.map((displayColumn: IDisplayColumn) => ({
        InternalName: displayColumn.internalName,
        DisplayName: displayColumn.displayName,
        IsDefault: displayColumn.isDefault,
        CustomWidth: displayColumn.customWidth ?? 0
    }));
};